import { graphql } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';

const Section = styled.section`
	padding-top: 0;
	padding-bottom: 1em;
`;

interface ProductPageProps {
	data: any;
}

const CopyrightPage: React.StatelessComponent<ProductPageProps> = function (props) {
	const {
		data: {
			markdownRemark,
		},
	} = props;

	return <Layout
			pageTitle={markdownRemark.frontmatter.title}
			splashHeaderMinHeight={'none'}
		>
			<div className='centeredWrapper'>
				<Section dangerouslySetInnerHTML={{ __html: markdownRemark.html }} />
			</div>
	</Layout>;
};

export const query = graphql`
	query($slug: String!) {
		markdownRemark(fields: { slug: { eq: $slug } }) {
			html
			frontmatter {
				title
			}
		}
	}
`;

export default CopyrightPage;
